import { KTIcon } from "../../../../_metronic/helpers";
import { useNavigate } from "react-router-dom";
import { PatternFormat } from "react-number-format";

const UserApiHeader = () => {
  const navigate = useNavigate();

  return (
    <div className="card-header border-0 pt-6 justify-content-between align-items-center" style={{ flexWrap: "nowrap", minHeight: 20 }}>
      <div className='d-flex column-gap-3'>

      </div>
    </div>
  );
};

export { UserApiHeader };
